import { type AxiosResponse } from 'axios';

import { BaseError } from './base.error';

type HttpClientErrorArgs<T = any> = {
  context?: Record<string, unknown>;
  message: string;
  response?: AxiosResponse<T>;
};

export class HttpClientError<T = any> extends BaseError {
  public readonly response?: AxiosResponse<T>;

  public readonly body: T | null;

  constructor({ context, message, response }: HttpClientErrorArgs<T>) {
    super(message, context);
    this.name = 'HttpClientError';
    this.response = response;
    this.body = response?.data ?? null;
  }
}
